<!-- 创建类型/修改类型弹窗 -->
<template>
    <div>
        <el-dialog :title="proTitle || title" :visible.sync="isShow" :modal-append-to-body="true" top="100px" width="30%"
            custom-class="custom-dialog-class" @close="closeCallBack">
            <template #default>
                <div class="dialog-container">
                    <el-form :model="form" ref="formRef" label-width="120px" :rules="rules">
                        <el-form-item label="类型名称：" prop="typeName">
                            <el-input v-model="form.typeName" clearable placeholder="请输入" maxlength="10"
                                show-word-limit />
                        </el-form-item>
                        <el-form-item class="nameItem" prop="material">
                            <template #label>
                                <span style="color: #F56C6C">* </span>食材：
                            </template>
                            <el-select :class="{ isInputError: isCheck }" v-model="selectedValue" value-key="id"
                                multiple filterable remote reserve-keyword placeholder="请输入食材名称"
                                :remote-method="searchMaterial" :loading="isLoading">
                                <el-option v-for="item in materialList" :key="item.id" :label="item.ingredientName"
                                    :value="item">
                                </el-option>
                            </el-select>
                            <div v-if="isCheck" class="errorMsg">*食材不能为空</div>
                        </el-form-item>
                        <template v-if="selectedValue.length">
                            <el-table :data="selectedValue" max-height="250">
                                <el-table-column prop="ingredientName" align="center" label="食材名称" />
                                <el-table-column align="center" label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="deleteRow(scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-form>
                </div>
            </template>
            <template #footer>
                <div class="dialog-footer">
                    <slot :isUpdate="isUpdate" :submitForm="() => checkForm('formRef')" :toggleOpen="() => toggleOpen(false)"></slot>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import { submitHint } from "../common";
import { get, post } from "@/api/http";
export default {
    name: "EditDialog",
    props: {
        toggleOpen: {
            type: Function,
            default: () => { },
        },
        isOpen: {
            type: Boolean,
            default: () => false,
        },
        submitCallBack: {
            type: Function,
            default: () => { },
        },
        // 每行数据
        row: {
            type: Object,
            default: () => {
                return {};
            },
        },
        closeCallBack: {
            typeof: Function,
            default: () => { },
        },
        // 区分是否是重新提交
        // reEdit - 重新提交
        operType: {
            type: String,
            default: '',
        },
        proTitle: {
            typeof: String,
            default: ''
        }
    },
    mounted() {
        if(this.row.id)  {
            this.title = '编辑类型';
        }
        this.form.id = this.row.id || ""; // 类型Id
        this.form.typeName = this.row.typeName || ""; // 类型名称
        /* 兼容审核中心 */
        this.selectedValue = this.row.foodName?.map(item => ({ id: item.id, ingredientName: item.foodName || item.ingredientName })) || [];
        this.materialList = this.row.foodName?.map(item => ({ id: item.id, ingredientName: item.foodName || item.ingredientName })) || [];
    },
    data() {
        return {
            form: {
                id: '',
                typeName: '',
            },
            rules: {
                typeName: [
                    { required: true, message: "请输入类型名称", trigger: "blur" },
                ]
            },
            isLoading: false,
            materialList: [],
            isShowHint: false, // 校验展示提醒
            selectedValue: [], // 选中食材id列表
            isCheck: false, // 校验是食材否通过
            title: '创建类型'
        }
    },
    computed: {
        isShow: {
            get() {
                return this.isOpen;
            },
            set(val) {
                this.toggleOpen(val);
            }
        },
        isUpdate(){
            const r1 = (this.form.typeName === this.row.typeName);
            const r2 = (this.selectedValue?.map(item => item.ingredientName).join(',') === this.row.foodName?.map(item => item.foodName).join(','));
            return r1 && r2;
        }
    },
    watch: {
        selectedValue(newVal) {
            if (newVal.length !== 0) {
                this.isCheck = false;
            }
        }
    },
    created() {
        if (this.isOpen) {
            this.form = { ...this.form, ...this.$route.query };
            this.selectedValue = this.form.material ? this.form.material.split(',').map(Number) : [];
        }
    },
    methods: {
        // 校验表单
        checkForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.selectedValue.length === 0) {
                        this.isCheck = true;
                        return;
                    }
                    this.submitFood();
                } else {
                    if (this.selectedValue.length === 0) {
                        this.isCheck = true;
                        return;
                    }
                    return false;
                }
            });
        },
        // 保存数据
        async submitFood() {
            const param = {
                id: this.form.id,
                typeName: this.form.typeName,
                foodName: this.selectedValue.map(item => item.ingredientName),
                foodObjList: JSON.stringify(this.selectedValue),
                userId: this.$store.state.user_info.userId,
            }
            // 审核中心重新提交复用
            if(this.operType === 'reEdit') {
                this.$emit('reEditCommit', param);
                return;
            }
            try {
                const result = await post("/diet/feedback/addOrUpdate", param);
                const { code, message } = result;
                if (code === "SUCCESS") {
                    this.toggleOpen(false); // 关闭弹窗
                    this.submitCallBack();
                    submitHint.call(this);
                } else {
                    this.$message.error(message);
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 查询食材列表
        async searchMaterial(val) {
            if (!val) {
                return;
            }
            try {
                this.isLoading = true;
                const result = await get(`/ingredient/list?pageNum=1&pageSize=1000&ingredientName=${val}&category=`);
                const { data: { list = [] } = {} } = result;
                this.materialList = list;
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
            }
        },
        // 提示信息展示
        toggleIsShowHint() {
            this.isShowHint = !this.isShowHint;
        },
        // 删除食材
        deleteRow(row) {
            this.selectedValue = this.selectedValue.filter(item => item.id !== row.id);
        }
    }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    width: 400px;
    margin: 0 auto;
}

.isInputError {
    border: 1px solid #F56C6C;
    border-radius: 4px;
}

.errorMsg {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    padding-bottom: 4px;
}

.hint {
    text-align: center;
}
</style>
